export default __webpack_public_path__ + "static/our-bees-dont-sting-badge-755d458b1bbdeffef5c6145b7c867ccd.svg";